/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationEventSubscription } from '../models/ApplicationEventSubscription';
import type { ApplicationEventSubscriptionCollection } from '../models/ApplicationEventSubscriptionCollection';
import type { ApplicationEventSubscriptionCreateRequest } from '../models/ApplicationEventSubscriptionCreateRequest';
import type { ApplicationEventSubscriptionUpdateRequest } from '../models/ApplicationEventSubscriptionUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApplicationEventSubscriptionsService {
    /**
     * Lists all application event subscriptions with optional filtering by client ID and/or event type
     * @returns ApplicationEventSubscriptionCollection Successful operation.
     * @throws ApiError
     */
    public static listApplicationEventSubscriptions({
        clientId,
        eventType,
        pageSize,
        pageToken,
    }: {
        /**
         * Optional client ID to filter subscriptions
         */
        clientId?: string,
        /**
         * Optional event type to filter subscriptions
         */
        eventType?: string,
        /**
         * Maximum number of items to return per page
         */
        pageSize?: number,
        /**
         * Token for retrieving the next page of results
         */
        pageToken?: string,
    }): CancelablePromise<ApplicationEventSubscriptionCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applicationEventSubscriptions',
            query: {
                'clientId': clientId,
                'eventType': eventType,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
        });
    }
    /**
     * Creates a new application event subscription
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static createApplicationEventSubscription({
        requestBody,
    }: {
        requestBody?: ApplicationEventSubscriptionCreateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/applicationEventSubscriptions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Gets details for a specific application event subscription
     * @returns ApplicationEventSubscription Successful operation.
     * @throws ApiError
     */
    public static getApplicationEventSubscription({
        subscriptionId,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
    }): CancelablePromise<ApplicationEventSubscription> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applicationEventSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * Updates an existing application event subscription
     * @returns ApplicationEventSubscription Successful operation.
     * @throws ApiError
     */
    public static updateApplicationEventSubscription({
        subscriptionId,
        requestBody,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
        requestBody?: ApplicationEventSubscriptionUpdateRequest,
    }): CancelablePromise<ApplicationEventSubscription> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/applicationEventSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes an application event subscription
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static deleteApplicationEventSubscription({
        subscriptionId,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/applicationEventSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
        });
    }
}
